import { render, staticRenderFns } from "./HeaderShopCart.vue?vue&type=template&id=2afba858&scoped=true&"
import script from "./HeaderShopCart.vue?vue&type=script&lang=js&"
export * from "./HeaderShopCart.vue?vue&type=script&lang=js&"
import style0 from "./HeaderShopCart.vue?vue&type=style&index=0&id=2afba858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afba858",
  null
  
)

export default component.exports